const pastBookingActions = ['resendConfirmationEmail', 'cancelOrder', 'changeRoom', 'changeDates']

export const filterActions = (action: any, isPastBooking: boolean, skipActions: Array<string> = []) => {
  const actionsToSkip = isPastBooking ? [...pastBookingActions, ...skipActions] : skipActions
  return isChip(action) && !actionsToSkip.includes(action?.action?.key)
}

export const isChip = (action: App.ChatMessageMetaContent) => action?.type === 'button'
export const isComponent = (action: App.ChatMessageMetaContent) => action?.type !== 'button'
